<template>
  <div></div>
</template>
<script>
import Api from "../includes/Api";
import {siteUrl} from "../config/config";

export default {
  name: "AthenaPlanDetail",
  data: function () {
    return {
      planId: ''
    }
  },
  mounted() {
    let app = this;
    localStorage.clear();
    app.planId = app.$route.params.id;
    window.localStorage.setItem('planId', app.$route.params.id);
    window.localStorage.setItem('planName', app.$route.params.planName);
    try {
      app.renderGroupInfo();
      app.directContinue();
    } catch (error) {
      app.$router.push(`/404`);
    }
  },
  methods : {
    directContinue: function () {
      let app = this;
      let landingParams = '316'
      return Api.get('/validate-landing-page?landing_page=' + landingParams)
          .then(function (response) {
            if (response.data.status == 'success') {
              app.$store.dispatch("isRepAuthenticated", true);
              app.$store.dispatch('landingInfo', response.data.data)
              app.$store.dispatch('landingUrl', landingParams)
              app.$store.commit('MUTATION_SET_ERROR', false);
              app.$store.dispatch("innerLandingRedirection", false);
              window.localStorage.setItem('agent_id', response.data.data.agent_id);
              window.localStorage.setItem('AGENT_ID', response.data.data.agent_id);
              window.localStorage.setItem('eprocess', 'applicant');
              window.localStorage.setItem('open_type', 'agent');
              app.routeToPlan();
            }
          });
    },
    renderGroupInfo () {
      Api.get('/get-domainSite-infromation?site_domain=' + window.btoa(unescape(encodeURIComponent( siteUrl )))).then((response)=> {
        if(response.data.statusCode == 200) {
          window.localStorage.setItem('group_id', response.data.data.gid);
          window.localStorage.setItem('portal_id', response.data.data.gid);
          window.localStorage.setItem('enroll_type', 'new-group-member');
        }
      }).catch(() => {})
    },
    routeToPlan() {
      let app = this
      let planId = window.localStorage.getItem('planId');
      let planName = window.localStorage.getItem('planName');
      app.$router.push(`/plan/${planId}/${planName}`)
      window.location.reload();
    }
  }
}
</script>
